import { FC, useState } from 'react';
import { useSelector } from 'react-redux';

import ArrowIcon from '../../../../assets/icons/chevron.svg';
import { shouldShowAiResults } from '../../../../utils/aiResults';
import { IUserOptions } from '../../../../types/interfaces';

const pad = (n: number) => String(n).padStart(2, '0');

/** Как в старом UI: 14.08.2026, 12:20:22 (локальное время). */
const formatAiTechDateTime = (value?: string | null): string => {
	if (!value) {
		return '—';
	}
	const date = new Date(value);
	if (Number.isNaN(date.getTime())) {
		return value;
	}
	return (
		`${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${date.getFullYear()}, ` +
		`${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
	);
};

const shortHash = (value?: string | null, len = 12): string => {
	if (!value) {
		return '—';
	}
	return value.slice(0, len);
};

const formatContractYolo = (contractYolo: any): string => {
	if (!contractYolo) {
		return '—';
	}
	const trained = formatAiTechDateTime(contractYolo.trainedAt);
	const markup = shortHash(contractYolo.datasetFingerprint, 12);
	const activation = shortHash(contractYolo.activationId, 8);
	return `Contract-YOLO: обучена ${trained} . разметка ${markup} . активация ${activation}`;
};

const formatPricetagYolo = (pricetagYolo: any): string => {
	if (!pricetagYolo) {
		return '—';
	}
	const trained = formatAiTechDateTime(
		pricetagYolo.trainedAt || pricetagYolo.weights?.modifiedAt
	);
	const markup = shortHash(pricetagYolo.datasetFingerprint, 12);
	return `YOLO ценников: обучена ${trained} . разметка ${markup}`;
};

const formatSigLipVlm = (aiReview: any): string => {
	const pipeline = aiReview?.modelProvenance?.pipeline || aiReview?.models || {};
	const embed = pipeline.embed || aiReview?.models?.embed;
	const gate = pipeline.gate || aiReview?.models?.gate;
	if (!embed && !gate) {
		return '—';
	}
	return [embed, gate].filter(Boolean).join(' . ');
};

const AiTechInfoTableSection: FC = () => {
	const { aiReview } = useSelector(
		(state: any) => state.userSingleReport.userSingleReport
	);
	const { claims, isCustomer, settings: userSettings } = useSelector(
		(state: IUserOptions) => state.user.user.data
	);
	const showAiResults = shouldShowAiResults(
		isCustomer,
		userSettings?.aiReview,
		claims
	);
	const [isVisibleData, setIsVisibleData] = useState(true);

	if (isCustomer || !showAiResults || !aiReview) {
		return null;
	}

	const provenance = aiReview.modelProvenance || {};
	const rows = [
		{
			label: 'Проверено',
			value: formatAiTechDateTime(aiReview.reviewedAt),
		},
		{
			label: 'Запуск',
			value: aiReview.pipelineRunId || '—',
		},
		{
			label: 'Товары',
			value: formatContractYolo(provenance.contractYolo),
		},
		{
			label: 'Ценники',
			value: formatPricetagYolo(provenance.pricetagYolo),
		},
		{
			label: 'SigLIP / VLM',
			value: formatSigLipVlm(aiReview),
		},
	];

	return (
		<div
			className={`sectionData ${
				isVisibleData ? 'sectionData_active sectionData__overflow' : ''
			}`}
		>
			<span className='section__title'>
				Техническая информация ИИ-проверки
			</span>
			<button
				className='sectionData_button'
				onClick={() => setIsVisibleData(!isVisibleData)}
			>
				<img src={ArrowIcon} alt='Custom Indicator' className='icon' />
			</button>
			<table className='customerOutlet__data_table'>
				<tbody>
					{rows.map((row) => (
						<tr key={row.label}>
							<td>{row.label}</td>
							<td>{row.value}</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};

export default AiTechInfoTableSection;
